var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 113.65,
    height: 113.65,
    viewBox: "0 0 113.65 113.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56.82,
    cy: 56.82,
    r: 56.82,
    fill: "#a9d0e0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "76.13 52.45 76.13 85.69 35.33 85.69 35.33 31.14 45.29 31.14",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "66.17 31.14 76.13 31.14 76.13 38.92",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45.29,
    y: 27.95,
    width: 20.89,
    height: 6.36,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.96,52.61c.49-.5,1.2-.74,1.9-.68l2.65.28c.74.08,1.47-.18,2-.71l2.62-2.62c.4-.4.65-.92.71-1.48l.48-4.4c.04-.38-.42-.59-.69-.33l-3.67,3.67c-.62.61-1.62.61-2.23,0l-1.61-1.62c-.61-.61-.61-1.61,0-2.23l3.67-3.67c.27-.27.05-.72-.33-.68l-4.4.47c-.56.07-1.09.32-1.48.71l-2.62,2.62c-.53.53-.79,1.26-.71,2l.27,2.66c.08.7-.18,1.4-.67,1.9l-13.24,13.23c-.49.5-1.2.74-1.9.68l-2.65-.28c-.74-.08-1.47.18-2,.71l-2.62,2.62c-.4.4-.65.92-.71,1.48l-.48,4.4c-.04.38.42.59.69.33l3.67-3.67c.62-.61,1.62-.61,2.23,0l1.61,1.62c.61.61.61,1.61,0,2.23l-3.67,3.67c-.27.27-.05.72.33.68l4.4-.47c.56-.07,1.09-.32,1.48-.71l2.62-2.62c.53-.53.79-1.26.71-2l-.27-2.66c-.08-.7.18-1.4.67-1.9l13.24-13.23Z",
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.56,
    y1: 41.59,
    x2: 62.84,
    y2: 41.59,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.56,
    y1: 48.24,
    x2: 59.97,
    y2: 48.24,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.56,
    y1: 54.89,
    x2: 57.23,
    y2: 54.89,
    fill: "none",
    stroke: "#dedede",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.4a2c4a794b008721d1388386eab9ff61.svg";
export { ForwardRef as ReactComponent };